import React from 'react';
import { FiTarget, FiInfo } from 'react-icons/fi';
import { AiOutlineDelete } from "react-icons/ai";

const ObjectiveForm = ({ formData, setFormData }) => {
  const [charCount, setCharCount] = React.useState(formData.objective?.length || 0);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCharCount(value.length);
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleRemove = () => {
    setFormData(prevState => ({
      ...prevState,
      objective: ''
    }));
    setCharCount(0);
  };

  return (
    <div className="form-section">
      <div className="form-group">
        <label className="input-label-large">
          <FiTarget style={{ display: 'inline', marginRight: '0.75rem', color: 'var(--crimson)' }} />
          Career Objective
        </label>
        
        <div className="helper-text" style={{ marginBottom: 'var(--space-md)' }}>
          <FiInfo className="helper-icon" />
          Write a compelling 2-3 sentence summary of your career goals and what you bring to the role
        </div>

        <textarea
          className='objective-text'
          name="objective"
          value={formData.objective}
          onChange={handleInputChange}
          placeholder="e.g., Passionate software engineer with 5+ years of experience in full-stack development. Seeking to leverage expertise in React and Node.js to build scalable applications that drive user engagement and business growth. Committed to writing clean, maintainable code and collaborating with cross-functional teams."
          maxLength={500}
        />
        
        <div className="char-counter">
          {charCount} / 500 characters
        </div>
      </div>

      {formData.objective && (
        <div className="button-group">
          <button className='remove-button' onClick={handleRemove}>
            <AiOutlineDelete />
            Clear Objective
          </button>
        </div>
      )}
    </div>
  );
};

export default ObjectiveForm;